import {REQUEST_TRANSPORTERS, REQUEST_TRANSPORTERS_FAILURE, REQUEST_TRANSPORTERS_SUCCESS} from "../../../constant/master/TransTransporterConstant";

const initialState = {
    transporters: {
        data: [],
        status: 'idle',
        isLoading: true,
    },
};


export const transportersReducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case REQUEST_TRANSPORTERS:
            return {
                ...state,
                transporters: {
                    data: [],
                    status: 'fetching',
                    isLoading: true,
                },
            };
        case REQUEST_TRANSPORTERS_SUCCESS:
            return {
                ...state,
                transporters: {
                    data: payload,
                    status: 'ready',
                    isLoading: false,
                },
            };
        case REQUEST_TRANSPORTERS_FAILURE:
            return {
                ...state,
                transporters: {
                    data: [],
                    status: 'fetching',
                },
            };
        default:
            return state;
    }
}
